import PropTypes from 'prop-types';
import { Link } from '@blaze-cms/nextjs-components';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

const getQueryName = entity => {
  if (entity === 'broker') return 'getPublishedBroker';
  if (entity === 'profile') return 'getPublishedProfile';

  return 'getPublishedBroker';
};

const getAdditionalParams = entity => {
  if (entity === 'profile') return 'profileRoles';

  return '';
};

const getQueryParams = (entity, data) => {
  if (entity === 'broker') return `?publishedBrokers.name=${encodeURIComponent(data.name)}`;

  if (entity === 'profile') {
    if (data.profileRoles.includes('Builder'))
      return `?publishedBuilderProfiles.name=${encodeURIComponent(data.name)}`;
    if (data.profileRoles.includes('Exterior Designer'))
      return `?publishedExteriorDesignerProfiles.name=${encodeURIComponent(data.name)}`;
    if (data.profileRoles.includes('Interior Designer'))
      return `?publishedInternalDesignerProfiles.name=${encodeURIComponent(data.name)}`;

    return `?publishedBuilderProfiles.name=${encodeURIComponent(data.name)}`;
  }

  return '';
};

const LinkWithSearchParam = ({ parent: { itemId, itemEntity }, href, text }) => {
  const { data, error, loading } = useQuery(
    gql`
    query getEntityData($id: String!){
      entityData: ${getQueryName(itemEntity)}(id: $id){
        id,
        name,
        ${getAdditionalParams(itemEntity)}
        __typename
      }
    }
  `,
    {
      variables: { id: itemId }
    }
  );

  if (loading) return 'loading...';
  if (error) return error.message;
  if (!data || !data.entityData) return null;

  const fullHref = `${href}${getQueryParams(itemEntity, data.entityData)}`;

  return (
    <Link
      href={fullHref}
      className="bi-card-block__yacht-search-link"
      data-gtm-id="yacht-search-link">
      {text}
    </Link>
  );
};

LinkWithSearchParam.propTypes = {
  href: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired
};

export default LinkWithSearchParam;
